export const privacyPolicyState = {
    errorCode : 0,
    statusCode : 0,
    updatedValue : [],
    Message : ''
}
